"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _settings = require("../data/settings");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const DEFAULT_PARAMS = {
  auto: 'compress,format'
};
const DEVICE_PIXEL_RATIOS = [1, 2, 3];
const ImgIX = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    params: userParams,
    src,
    alt,
    ...props
  } = _ref;
  const url = new URL(_settings.ASSETS_CDN);
  url.pathname = src;
  _lodash.default.each(DEFAULT_PARAMS, (value, key) => url.searchParams.set(key, value));
  _lodash.default.each(userParams, (value, key) => url.searchParams.append(key, value));
  return /*#__PURE__*/_react.default.createElement("img", _extends({
    ref: ref
  }, props, {
    src: url.href,
    alt: alt,
    srcSet: _lodash.default.map(DEVICE_PIXEL_RATIOS, dpr => {
      const srcSetUrl = new URL(url);
      srcSetUrl.searchParams.set('dpr', dpr);
      return "".concat(srcSetUrl.href, " ").concat(dpr, "x");
    }).join(',')
  }));
});
ImgIX.defaultProps = {
  alt: ''
};
ImgIX.propTypes = {
  params: _propTypes.default.object,
  src: _propTypes.default.string.isRequired,
  alt: _propTypes.default.string.isRequired,
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  loading: _propTypes.default.oneOf(['eager', 'lazy'])
};
var _default = exports.default = ImgIX;